import { ArrowLeftIcon, ArrowRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { useEnv } from "~/use-env";

export default function PhotoGallery(props: any) {

	const { images } = props;
	const env = useEnv();
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [showPreview, setShowPreview] = useState(false);
	const imgRef = useRef<HTMLImageElement>(null);

	function handleClick(navigate: 'previous' | 'next') {
		let newIndex;
		if (navigate === 'previous') {
			newIndex = getPreviousIndex(images, selectedImageIndex, true)
		}
		if (navigate === 'next') {
			newIndex = getNextIndex(images, selectedImageIndex, true)
		}
		newIndex = newIndex ? newIndex : 0;
		setSelectedImageIndex(newIndex);
	}

	function getPreviousIndex(arr: any[], currentIndex: number, wrap = false) {
		const targetIndex = currentIndex - 1;
		let previousIndex;
		if (wrap) {
			if (targetIndex < 0) {
				previousIndex = arr.length - 1;
			} else {
				previousIndex = targetIndex;
			}
		} else {
			if (targetIndex < 0 || targetIndex >= arr.length) {
				previousIndex = null;
			} else {
				previousIndex = targetIndex;
			}
		}

		return previousIndex;
	}

	function getNextIndex(arr: any[], currentIndex: number, wrap = false) {
		const targetIndex = currentIndex + 1;

		let nextIndex;
		if (wrap) {
			if (targetIndex >= arr.length) {
				nextIndex = 0;
			} else {
				nextIndex = targetIndex;
			}
		} else {
			if (targetIndex < 0 || targetIndex >= arr.length) {
				nextIndex = arr.length - 1;
			} else {
				nextIndex = targetIndex;
			}
		}

		return nextIndex;
	}

	if (!images?.length) {
		return ``;
	}

	const activeImageUrl = env.appUrl + '/' + images[selectedImageIndex].fullPath;

	return (
		<>
			<div className="photo-gallery w-full max-w-2xl mx-auto sm:block lg:max-w-none">
				<span className="overflow-hidden">
					<div className="relative w-full h-full" >
						<img
							src={activeImageUrl}
							alt=""
							className="w-full h-full object-center object-cover rounded-lg"
							onClick={() => setShowPreview(true)}
						/>
						{ images.length > 1 ?(<>
							<button className="img-nav-btn absolute top-1/2 left-2 transform -translate-y-1/2 bg-white px-2 py-1 rounded-md z-10 transition ease-in-out delay-150 hover:scale-110" onClick={() => { handleClick("previous") }}>
								<ArrowLeftIcon></ArrowLeftIcon>
							</button>
							<button className="img-nav-btn absolute top-1/2 right-2 transform -translate-y-1/2 bg-white px-2 py-1 rounded-md z-10 transition ease-in-out delay-150 hover:scale-110" onClick={() => { handleClick("next") }}>
								<ArrowRightIcon></ArrowRightIcon>
							</button>
						</>) : '' }

					</div>
				</span>
				<div className="row flex photo-row w-full ">
					{images.map((i: { id: number; fullPath: string; featured: boolean; }, index: number) => {
						return (
							<div key={index} className="col" onClick={() => setSelectedImageIndex(index)}>
								<img src={env.appUrl + '/' + i.fullPath}
									ref={i.featured ? imgRef : null}
									alt=""
									className={`photo-row-item object-center object-cover ${index === selectedImageIndex ? 'selected' : ''}`}
								/>
							</div>
						)
					})}

				</div>

			</div>
			{showPreview ? (
				<div className="preview-container" onClick={() => setShowPreview(false)}>
					<div className="backdrop">
						<button className="close-button">
							<XMarkIcon></XMarkIcon>
						</button>
					</div>

					<div className="preview-image-wrapper">
						<img className="preview-image" src={activeImageUrl} alt="Preview Image" />
					</div>
				</div>
			) : ''}

		</>
	)
}